import React, { useState } from 'react';
import { Button, Form, Table } from 'react-bootstrap';
import { mappedMPNs } from '../services/partMapping';
import { canEditRow } from '../services/bomDrafts';
import QuoteComparison from './QuoteComparison';

export default function MappedPartDetail({ bom, group, busy, locked, onStage, onChanged, onMutating }) {
  const [page, setPage] = useState(0);
  const [quoteLine, setQuoteLine] = useState(null);
  const sources = group.sourceRows;
  const lastPage = Math.max(0, Math.ceil(sources.length / 10) - 1);
  const currentPage = Math.min(page, lastPage);
  const quoteRow = sources.find(row => row.line_item_id === quoteLine);
  return <div className="p-3">
    <h3 className="h6">Mapped manufacturer part numbers</h3>
    <p className="text-muted small">MPNs are alternatives, not extra quantity-bearing lines.
      Edit each original source line below; comma-separated MPNs share the same source fields.
      Changes are drafts until you choose Save changes.</p>
    {sources.slice(currentPage * 10, (currentPage + 1) * 10).map(row => {
      const mpns = mappedMPNs(row, bom.part_mapping);
      return <section key={row.line_item_id} className="border rounded p-2 mb-3"
        aria-label={`Source line ${row.order_index + 1}`}>
        <div className="d-flex align-items-center gap-2 mb-2">
          <strong>Source line {row.order_index + 1}</strong>
          {row.quote_access !== false && <Button size="sm" variant="outline-secondary" disabled={busy}
            onClick={() => setQuoteLine(previous => previous === row.line_item_id ? null : row.line_item_id)}>
            {quoteLine === row.line_item_id ? 'Hide quotes' : 'View quotes'} for line {row.order_index + 1}
          </Button>}
        </div>
        <Table bordered size="sm" aria-label={`MPN subrows for source line ${row.order_index + 1}`}>
          <thead><tr><th>Manufacturer part number</th></tr></thead>
          <tbody>{mpns.length ? mpns.map((mpn, index) => <tr key={index}><td>↳ {mpn}</td></tr>)
            : <tr><td className="text-muted">No mapped MPNs</td></tr>}</tbody>
        </Table>
        <details><summary>Source fields — {canEditRow(row, bom.policy) ? 'edit original line' : 'read-only'}</summary>
          <div className="d-flex flex-wrap gap-2 mt-2">
            {bom.columns.map(column => <Form.Group key={column.id} style={{ width: 220 }}
              controlId={`source-${row.line_item_id}-${column.id}`}>
              <Form.Label className="small mb-1">{column.name}</Form.Label>
              <Form.Control size="sm" value={String(row.data[column.id] ?? '')} maxLength={10000}
                disabled={busy} readOnly={!canEditRow(row, bom.policy) || !bom.policy.write_columns.includes(column.id)}
                onChange={event => onStage({ ...row, data: { ...row.data, [column.id]: event.target.value } })} />
            </Form.Group>)}
          </div>
        </details>
      </section>;
    })}
    {sources.length > 10 && <div className="d-flex align-items-center gap-2 mb-3">
      <Button size="sm" disabled={currentPage === 0} onClick={() => setPage(currentPage - 1)}>Previous source lines</Button>
      <span>Page {currentPage + 1} of {lastPage + 1}</span>
      <Button size="sm" disabled={currentPage === lastPage} onClick={() => setPage(currentPage + 1)}>Next source lines</Button>
    </div>}
    {quoteRow && <QuoteComparison bom={bom} row={quoteRow} locked={locked}
      onChanged={onChanged} onMutating={onMutating} />}
  </div>;
}
